export class PasswordResetRequestModel {
    loginId: string | null = null;
    phoneNumber: string | null = null;

    constructor(data?: Partial<PasswordResetRequestModel>) {
        Object.assign(this, data);
    }
}
